import * as S from './Radio.styled';

const Radio = ({ id, checked, onChange, disabled = false }) => {
  return (
    <S.RadioWrap>
      <input
        id={id}
        type='checkbox'
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ width: '100%', height: '100%', opacity: '0' }}
      />
      <S.Radio disabled={disabled}></S.Radio>
    </S.RadioWrap>
  );
};

export default Radio;
